import React, { useState, forwardRef, useEffect, useImperativeHandle } from 'react';
import { HttpService } from '../../apiAuthorization/httpService';
import { Checkbox, FormGroup, FormControlLabel, Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const RestraintCheckList = forwardRef((props, ref) => {
    const { restraintCheckListItem, close, initRestraintCheckListItem, autoPopulateInterventionOptions, getRestraintCheckList} = props;
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const closeErrorSnackbar = () => {
        setOpenError(false);
    };
    const openErrorSnackbar = () => {
        setOpenError(true);
    };
    const [restraintTypes, setRestraintTypes] = useState([
        { Id: 1, Checked: false, Text: "Soft restraints (e.g. Mitten) - Sometimes referred to as mitten restraints, which are soft wrist and limb restraints" },
        { Id: 2, Checked: false, Text: 'Locked (Hard) restraints – Mostly on all four limbs and considered "hard restraint"' },
        { Id: 3, Checked: false, Text: "Chest restraint"},
        { Id: 4, Checked: false, Text: "Lap belt"},
        { Id: 5, Checked: false, Text: "Facial restraint – Prevents spitting and biting" },
    ]);

    const setOptions = () => {
        if (restraintCheckListItem.RestraintTypesArr && restraintCheckListItem.RestraintTypesArr.length > 0) {
            setRestraintTypes(restraintCheckListItem.RestraintTypesArr);
        }
    }

    const saveRestraintCheckList = () => {

        let error = true;
        restraintTypes.forEach(x => {
            if (x.Checked) {
                error = false;
            }
        });

        if (error) {
            setErrorMessage("Please select at least one item.");
            openErrorSnackbar();
            return false;
        }

        restraintCheckListItem.RestraintTypes = JSON.stringify(restraintTypes);
        restraintCheckListItem.Started = false;
        HttpService.post('/PatientSitting/SaveRestraintCheckList',
            restraintCheckListItem
        )
        .then((result) => {
            initRestraintCheckListItem();
            getRestraintCheckList();
            autoPopulateInterventionOptions(false, true);
            close();
        });
    }

    useImperativeHandle(ref, () => {
        return {
            save: saveRestraintCheckList
        };
    });

    useEffect(() => {
        setOptions();
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
                <Alert onClose={closeErrorSnackbar} severity="error">
                    {errorMessage}
                </Alert>
            </Snackbar>
            <FormGroup style={{ display: "flex" }}>
                {
                    restraintTypes.map((item) => {
                        return (
                            <FormControlLabel
                                key={item.Id}
                                control={
                                    <Checkbox
                                        onChange={(e) => { item.Checked = e.target.checked; }}
                                        value="Checked"
                                    />
                                }
                                label={item.Text}
                                style={{ color: '#4183c4' }}
                            />
                        )
                    })
                }
            </FormGroup>
        </div>
    );
});
export default RestraintCheckList;